import firebaseSrv from '@/services/firebaseSrv.js'
import cookie from 'vue-cookie'

export const namespaced = true

/*
function compareValues(key, order = 'asc') {
  return function(a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      return 0
    }

    const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key]
    const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key]

    let comparison = 0
    if (varA > varB) {
      comparison = 1
    } else if (varA < varB) {
      comparison = -1
    }
    return order == 'desc' ? comparison * -1 : comparison
  }
}
*/

export const state = {
  entries: {},
  allEntries: {},
  progressModal: false,
  admin: false
}
export const mutations = {
  ALL_ENTRIES(state, entries) {
    state.entries = entries
    state.allEntries = entries
  },
  FILTERED_ENTRIES(state, entries) {
    state.entries = entries
  },
  RESET_ENTRIES(state) {
    state.entries = state.allEntries
  },
  UPDATE_COMMENT(state, payload) {
    const entry = state.entries[payload.doc]
    const score = entry.scores[payload.currentJudge]
    score.comment = payload.comment
  },
  UPDATE_SCORE(state, payload) {
    const entry = state.entries[payload.doc]
    const score = entry.scores[payload.currentJudge]
    // const aVal = score.score[payload.dimension]
    //console.log(aVal)
    score.score[payload.dimension] = payload.value
  },
  UPDATE_VIEWED(state, payload) {
    const entry = state.entries[payload.doc]
    const score = entry.scores[payload.currentJudge]
    score.viewed = true
  },
  UPDATE_TOTAL(state, payload) {
    const entry = state.entries[payload.doc]
    const score = entry.scores[payload.currentJudge]
    console.log('total: ' + payload.total)
    score.total = payload.total
  },
  UPDATE_PROGRESS_MODAL(state) {
    state.progressModal = true
  }
}
export const getters = {
  allEntryArray: state => {
    let entries = Object.values(state.allEntries)
    return entries
  },
  entryArray: state => {
    let entries = Object.values(state.entries)
    return entries
  },
  entryCount: (state, getter) => {
    return getter.entryArray.length
  },
  currentEntry: state => ceid => {
    let entriesArray = Object.keys(state.entries)
    return entriesArray.findIndex(needle => needle == ceid)
  },
  currentScore: (state, getter, rootState) => ceid => {
    const entry = state.entries[ceid]
    // console.log('currentScore:' + JSON.stringify(entry))
    const score = entry.scores[rootState.currentUser]
    // console.log('currentScore:' + rootState.currentUser)
    const scoreArray = Object.values(score.score)
    const total = scoreArray.reduce((partial_sum, a) => partial_sum + a)
    return total > -1 && !scoreArray.includes(-1) ? total : -1
  },
  scores: (state, getter, rootState) => {
    console.log('scores:' + rootState.currentUser)
    let scores = []
    getter.allEntryArray.forEach(entry => {
      scores.push(entry.scores[rootState.currentUser])
    })
    return scores
  },
  seen: (state, getter) => {
    let seen = getter.scores.filter(score => score.viewed === true)
    return seen.length
  },
  startedScoring: (state, getter) => {
    let started = getter.scores.filter(score => {
      const scoreArray = Object.values(score.score)
      const total = scoreArray.reduce((partial_sum, a) => partial_sum + a)
      return scoreArray.includes(-1) && total > -4
    })
    return started.length
  },
  zero: (state, getter) => {
    let zero = getter.scores.filter(score => {
      const scoreArray = Object.values(score.score)
      const total = scoreArray.reduce((partial_sum, a) => partial_sum + a)
      return total == 0 && !scoreArray.includes(-1)
    })
    return zero.length
  },
  scored: (state, getter) => {
    let scored = getter.scores.filter(score => {
      const scoreArray = Object.values(score.score)
      const total = scoreArray.reduce((partial_sum, a) => partial_sum + a)
      return total > 0 && !scoreArray.includes(-1)
    })
    return scored.length
  },
  loved: (state, getter) => {
    let loved = getter.scores.filter(score => {
      const scoreArray = Object.values(score.score)
      return scoreArray.includes(5) && !scoreArray.includes(-1)
    })
    return loved.length
  },
  commentCount: (state, getter) => {
    let comments = getter.scores.filter(score => score.comment.length > 0)
    return comments.length
  },
  judgeScoreCount: (state, getter) => judgeID => {
    let count = 0
    getter.allEntryArray.forEach(entry => {
      let thisJudge = entry.scores[judgeID]
      if (thisJudge.total > -1) {
        count++
      }
    })
    return count
  },
  judgeViewedCount: (state, getter) => judgeID => {
    let count = 0
    getter.allEntryArray.forEach(entry => {
      let thisJudge = entry.scores[judgeID]
      if (thisJudge.viewed == true) {
        count++
      }
    })
    return count
  }
}
export const actions = {
  getEntries({ commit, getters, rootState }) {
    // console.log('judging/getEntries')
    const judgeID = rootState.currentUser
    return firebaseSrv.readEntriesForReview(judgeID).then(docs => {
      commit('ALL_ENTRIES', docs)
      cookie.set('entryCount', getters.entryCount, 1)
      cookie.delete('filterEntries')
      // console.log('Cookie: ' + cookie.get('entryCount'))
    })
  },
  updateComment({ commit }, payload) {
    commit('UPDATE_COMMENT', payload)
  },
  updateScore({ commit }, payload) {
    // console.log(payload)
    commit('UPDATE_SCORE', payload)
  },
  updateViewed({ commit }, payload) {
    // console.log(payload)
    commit('UPDATE_VIEWED', payload)
  },
  updateTotal({ commit }, payload) {
    // console.log('updateTotal')
    commit('UPDATE_TOTAL', payload)
  },

  //  updateScore(judgeID, scoreOb, entryID)
  updateDB({ dispatch, rootState }, payload) {
    const judgeID = rootState.currentUser
    firebaseSrv
      .updateScore(judgeID, payload.scoreOb, payload.entryID)
      .catch(error => {
        // console.log('ITS NOT WORKING')
        const notification = {
          title: 'There is a problem with your review',
          type: 'error',
          code: error.code,
          message: error.message
        }
        return dispatch('notification/add', notification, { root: true })
      })
  },
  PARKEDfilterSeen({ commit, rootState }, condition) {
    const judgeID = rootState.currentUser
    return firebaseSrv
      .readEntriesForReview(judgeID)
      .then(entrysObject => {
        let filteredObject = {}
        const entryArray = Object.values(entrysObject)
        const filteredArray = entryArray.filter(
          entry => entry.scores[judgeID].viewed == condition
        )
        filteredArray.forEach(entry => {
          let obj = { [entry.ceid]: entry }
          filteredObject = Object.assign(obj, filteredObject)
        })
        return filteredObject
      })
      .then(filteredObject => commit('ALL_ENTRIES', filteredObject))
  },
  filterSeen({ commit, getters, rootState }, condition) {
    commit('RESET_ENTRIES')
    const judgeID = rootState.currentUser
    let filteredObject = {}
    // const entryArray = Object.values(entrysObject)
    const filteredArray = getters.entryArray.filter(
      entry => entry.scores[judgeID].viewed == condition
    )
    filteredArray.reverse()
    filteredArray.forEach(entry => {
      let obj = { [entry.ceid]: entry }
      filteredObject = Object.assign(obj, filteredObject)
    })
    commit('FILTERED_ENTRIES', filteredObject)
  },
  filterScored({ commit, getters, rootState }, condition) {
    commit('RESET_ENTRIES')
    const judgeID = rootState.currentUser
    let filteredObject = {}
    let filteredArray = condition
      ? getters.entryArray.filter(entry => entry.scores[judgeID].total > -1)
      : getters.entryArray.filter(entry => entry.scores[judgeID].total == -1)
    filteredArray.reverse()
    filteredArray.forEach(entry => {
      let obj = { [entry.ceid]: entry }
      filteredObject = Object.assign(obj, filteredObject)
    })
    commit('FILTERED_ENTRIES', filteredObject)
  }
}
